import React, { useState } from "react";
import suraasaLogo from "./suraasa-logo.png"; // ensure exact filename and path

function App() {
  const [email, setEmail] = useState("");
  const [curriculum, setCurriculum] = useState("");
  const [subject, setSubject] = useState("");
  const [experience, setExperience] = useState("");
  const [qualification, setQualification] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [score, setScore] = useState(null);
  const [scholarship, setScholarship] = useState(null);

  // --- calculate function ---
  const calculate = () => {
    let total = 0;

    const scoring = {
      curriculum: {
        "International Curriculum": 3,
        "National Curriculum": 2,
        "Not Teaching Currently": 1,
      },
      subject: {
        STEM: 3,
        "Non-STEM": 2,
        Vocational: 1,
      },
      experience: {
        ">5": 3,
        "2-5": 2,
        "<2": 1,
      },
      qualification: {
        "PhD or M.Ed": 3,
        "B.Ed": 2,
        "Diploma or None": 1,
      },
    };

    total += scoring.curriculum[curriculum] || 0;
    total += scoring.subject[subject] || 0;
    total += scoring.experience[experience] || 0;
    total += scoring.qualification[qualification] || 0;

    setScore(total);

    let amount = 0;

    // --- Scholarship logic by currency ---
    if (currency === "INR") {
      if (total >= 10) amount = 12500;
      else if (total >= 7) amount = 8000;
      else if (total >= 5) amount = 4000;
      else amount = 2500;
    } else if (currency === "USD") {
      if (total >= 10) amount = 125;
      else if (total >= 7) amount = 90;
      else if (total >= 5) amount = 40;
      else amount = 25;
    } else if (currency === "AED") {
      if (total >= 10) amount = 500;
      else if (total >= 7) amount = 300;
      else if (total >= 5) amount = 150;
      else amount = 100;
    }

    setScholarship(amount);

    // Optional: Send data to Google Sheet
    const formData = {
      email,
      curriculum,
      subject,
      experience,
      qualification,
      score: total,
      scholarship: `${amount} ${currency}`,
    };

    fetch(
      "https://script.google.com/macros/s/AKfycbx1vJnkC0jRub2_gWW7tADwHQuVlCD3Jrl3tCkhikcm_F-pzyN9cJfGkRjjPt1S-bFq/exec",
      {
        method: "POST",
        body: JSON.stringify(formData),
        headers: { "Content-Type": "application/json" },
      }
    )
      .then((res) => res.json())
      .then((data) => console.log("Saved to Google Sheet:", data))
      .catch((err) => console.error("Error:", err));
  };

  const resetForm = () => {
    setEmail("");
    setCurriculum("");
    setSubject("");
    setExperience("");
    setQualification("");
    setCurrency("INR");
    setScore(null);
    setScholarship(null);
  };

  // --- Currency symbol display ---
  const getSymbol = () => {
    if (currency === "USD") return "$";
    if (currency === "AED") return "AED ";
    return "₹";
  };

  return (
    <div
      style={{
        fontFamily: "'Inter', sans-serif",
        backgroundColor: "#f6f8fc",
        minHeight: "100vh",
        padding: "40px 20px",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "30px",
          gap: "15px",
        }}
      >
        <img src={suraasaLogo} alt="Suraasa Logo" style={{ height: "60px" }} />
        <h1 style={{ color: "#1c3f94", fontWeight: 700 }}>
          Educator Excellence Grant
        </h1>
      </div>

      {/* Layout */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: "30px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {/* Left Section: Form */}
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            padding: "30px 40px",
            width: "420px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          }}
        >
          <h2 style={{ color: "#1c3f94", textAlign: "center" }}>Profile Details</h2>

          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter learner email"
            style={inputStyle}
          />

          <label>Currency</label>
          <select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            style={selectStyle}
          >
            <option value="INR">INR (₹)</option>
            <option value="USD">USD ($)</option>
            <option value="AED">AED (د.إ)</option>
          </select>

          <label>Curriculum</label>
          <select
            value={curriculum}
            onChange={(e) => setCurriculum(e.target.value)}
            style={selectStyle}
          >
            <option value="">Select</option>
            <option>International Curriculum</option>
            <option>National Curriculum</option>
            <option>Not Teaching Currently</option>
          </select>

          <label>Subject</label>
          <select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={selectStyle}
          >
            <option value="">Select</option>
            <option>STEM</option>
            <option>Non-STEM</option>
            <option>Vocational</option>
          </select>

          <label>Experience</label>
          <select
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            style={selectStyle}
          >
            <option value="">Select</option>
            <option value=">5">More than 5 years</option>
            <option value="2-5">2–5 years</option>
            <option value="<2">Less than 2 years</option>
          </select>

          <label>Teaching Qualification</label>
          <select
            value={qualification}
            onChange={(e) => setQualification(e.target.value)}
            style={selectStyle}
          >
            <option value="">Select</option>
            <option>PhD or M.Ed</option>
            <option>B.Ed</option>
            <option>Diploma or None</option>
          </select>

          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button onClick={calculate} style={primaryBtn}>
              Calculate
            </button>
            <button onClick={resetForm} style={secondaryBtn}>
              Reset
            </button>
          </div>
        </div>

        {/* Right Section: Scholarship Result */}
        <div
          style={{
            backgroundColor: "#1c3f94",
            color: "white",
            borderRadius: "12px",
            padding: "40px 35px",
            width: "380px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
            textAlign: "center",
          }}
        >
          <h2 style={{ marginBottom: "15px" }}>Scholarship Result</h2>

          {score !== null ? (
            <>
              <h1 style={{ fontSize: "36px", color: "#ffca28" }}>
                {getSymbol()}
                {scholarship.toLocaleString("en-IN")}
              </h1>
              <p style={{ fontSize: "16px" }}>
                Based on your profile and experience, you are eligible for the{" "}
                <strong>Educator Excellence Grant</strong>.
              </p>

              <div
                style={{
                  marginTop: 20,
                  backgroundColor: "#fff",
                  color: "#1c3f94",
                  padding: "15px",
                  borderRadius: "8px",
                }}
              >
                <p style={{ margin: 0, fontWeight: 600 }}>
                  Total Score: {score} / 12
                </p>
              </div>
            </>
          ) : (
            <p style={{ opacity: 0.8 }}>
              Fill in your details and click <strong>Calculate</strong> to see
              your scholarship amount.
            </p>
          )}

          {/* About Suraasa Section */}
          <div
            style={{
              marginTop: "40px",
              paddingTop: "20px",
              borderTop: "1px solid rgba(255,255,255,0.3)",
            }}
          >
            <h3 style={{ color: "#ffca28" }}>About Suraasa</h3>
            <p style={{ fontSize: "15px", lineHeight: "1.6" }}>
              Suraasa empowers educators to upskill and advance their teaching
              careers through world-class training, mentorship, and globally
              recognized teaching qualifications.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  margin: "8px 0 16px",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const selectStyle = { ...inputStyle };

const primaryBtn = {
  padding: "10px 16px",
  backgroundColor: "#1c3f94",
  color: "white",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: 500,
};

const secondaryBtn = {
  padding: "10px 16px",
  backgroundColor: "#e0e6f6",
  color: "#1c3f94",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: 500,
};

export default App;
